// extracted by mini-css-extract-plugin
module.exports = {"container":"Z2LOcrvnVaxWMVpyJC11a","title":"_3vSDzBNWsPFNNQlRzeExpI"};